"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../helpers");
function getLocaleString(dictionary, locale) {
    var dict = helpers_1.safeParseJSON(dictionary);
    return dict[locale] ? dict[locale] : helpers_1.getFirstElement(dict);
}
exports.getLocaleString = getLocaleString;
//# sourceMappingURL=language.js.map